import * as React from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';

import * as styles from './Header.css';
import ConsultantMobile from './images/consultantMobile.svg';

export interface IHeaderProps {
  buttonsRef: React.RefObject<HTMLDivElement>;
  onCallButtonClick: () => void;
  onRequestButtonClick: () => void;
}

export const Header: React.FC<IHeaderProps> = ({ buttonsRef, onCallButtonClick, onRequestButtonClick }) => {
  const deviceType = useDeviceType();

  const isMobile = deviceType === 'phone' || deviceType === 'tablet';
  const buttonSize: TButtonSize = isMobile ? 'M' : 'L';

  return (
    <section className={styles['header']} data-testid="LandingPageHeader">
      {isMobile && <img src={ConsultantMobile} className={styles['consultant-image']} />}
      <div className={styles['text']}>
        <h1 className={styles['title']}>
          <span className={styles['free']}>Бесплатно </span>поможем выбрать квартиру в&nbsp;новостройке
        </h1>
        <div className={styles['description']}>
          Консультант Циан подберёт квартиру по вашим параметрам и ответит на все вопросы
        </div>
        <div className={styles['button-group']}>
          <div ref={buttonsRef}>
            <div className={styles['button']}>
              <Button size={buttonSize} fullWidth onClick={onCallButtonClick} data-testid="ContactsHeaderButton">
                Позвонить консультанту
              </Button>
            </div>
            <div className={styles['button']}>
              <Button
                size={buttonSize}
                fullWidth
                theme="fill_white_primary"
                onClick={onRequestButtonClick}
                data-testid="RequestFormButton"
              >
                Оставить заявку
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
